import MaskedInput from 'react-text-mask'
import React from 'react'

import { masks } from '../../../utils'

const ZipCodeInput = ({ inputRef, ...rest }) => (
  <MaskedInput
    ref={ref => {
      inputRef(ref ? ref.inputElement : null)
    }}
    mask={masks.zipCodeMask}
    showMask
    guide={false}
    {...rest}
  />
)

export default ZipCodeInput
